import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ApiStatus } from '../../api/apiStatus';
import { AxiosResponse } from 'axios';
import { importPhotoDayFile } from '../../api/photoDayImportApi';
import { PhotoDayBody } from '../../model/photo-day-body';

export interface EventState {
  importPhotoDayFile ?: PhotoDayBody;
  status: ApiStatus;
  refreshStatus: ApiStatus;
  completeStatus: ApiStatus;
}

const initialState: EventState = {
  importPhotoDayFile : { },
  status: null,
  refreshStatus: null,
  completeStatus: null,
};

export const importPhotoDay = createAsyncThunk('photoDayImport/importPhotoDayFile', async (eventId: string, { rejectWithValue }) => {
    try {
      return await importPhotoDayFile(eventId);
    } catch (err: any) {
      return rejectWithValue((err.response as AxiosResponse).data?.message as string);
    }
  });


  export const photoDayImportSlice = createSlice({
    name: 'photoDayImport',
    initialState,
    reducers: {
      resetEventState: (state) => {
        state.importPhotoDayFile = initialState.importPhotoDayFile;
        state.status = initialState.status;
        state.completeStatus = initialState.completeStatus;
        state.refreshStatus = initialState.refreshStatus;
        
      },

      resetCompleteStatus: (state) => {
        state.completeStatus = null;
        state.importPhotoDayFile = {};

      },
    },
    // setup extra reducers to handle actions generated by createAsyncThunk
    extraReducers: (builder) => {
      builder
        .addCase(importPhotoDay.pending, (state, action) => {
          state.status = 'LOADING';
          state.importPhotoDayFile = {}
        })
        .addCase(importPhotoDay.fulfilled, (state, action) => {
          state.status = 'SUCCESS';
          state.importPhotoDayFile = action.payload
        })
        .addCase(importPhotoDay.rejected, (state, action) => {
          state.status = 'FAILED';
          state.importPhotoDayFile = {}
        })
    },
  });

  export const selectStatus = (state : RootState) => state.photoDayImport.status;
  export const selectImportPhotoDayFile = (state: RootState) => state.photoDayImport.importPhotoDayFile;

  //Export Actions
  export const { resetEventState, resetCompleteStatus } = photoDayImportSlice.actions;

  //Export Reducer
  export default photoDayImportSlice.reducer;

